/**
 * @file PlacementBinField.tsx
 * @description Поле ячейки размещения: скан или адрес ячейки, полки,
 * стеллажа (phase19.24 этап 1, шаг 4; на общий `BinScanField` —
 * phase19.22, W14-9).
 *
 * Одно поле на два способа ввода — правило warehouse-UI: USB-сканер печатает
 * `LOC:A-01-01`, кладовщик набирает `A-01` руками и выбирает ячейку плиткой
 * полки. Разбор уровня — сервер (`scan/resolve`), ошибки («не найден», «в
 * архиве», «это код товара») поле показывает само, а не тостом.
 */

import { BinScanField } from "../bins/BinScanField";
import type { StorageBinDto } from "../../../lib/api-bins";

interface Props {
  label: string;
  /** Склад размещения — в нём ищется скан. */
  warehouseId: string;
  /** Ячейки склада — подпись выбранной по id. */
  bins: StorageBinDto[];
  value: string;
  onChange: (binId: string) => void;
  /** В строке списка: без подсказки под полем. */
  compact?: boolean;
  disabled?: boolean;
}

export function PlacementBinField({
  label,
  warehouseId,
  bins,
  value,
  onChange,
  compact = false,
  disabled = false,
}: Props) {
  return (
    // Не `<label>`: внутри поля плитки уровня и кнопка сброса.
    <div className="flex flex-col gap-1">
      <span className="label-editorial">{label}</span>
      <BinScanField
        warehouseId={warehouseId}
        bins={bins}
        value={value}
        onChange={onChange}
        compact={compact}
        disabled={disabled}
      />
    </div>
  );
}
